export default "__VITE_ASSET__CN_BCI5S__"